import { render, staticRenderFns } from "./AppleRegistration.vue?vue&type=template&id=50d7612d&"
import script from "./AppleRegistration.vue?vue&type=script&lang=js&"
export * from "./AppleRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports